module.exports = __webpack_public_path__ + "static/media/Reports.b940a9e5.svg";